var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"ViewHeading"},[_vm._v("Battery Overview")]),_c('div',[_c('b-card',[_c('b-tabs',{attrs:{"card":""}},[_c('b-tab',{attrs:{"active":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" O1 Devices ")]},proxy:true}])},[_vm._v(" show status here, option to mark as changed ")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }